if (!customElements.get("variant-selects")) {
	customElements.define(
		"variant-selects",
		class VariantSelects extends HTMLElement {
			constructor() {
				super();
			}

			get selectedOptionValues() {
				return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(({ dataset }) => dataset.optionValueId);
			}

			getInputForEventTarget(target) {
				return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
			}

			connectedCallback() {
				this.addEventListener("change", (event) => {
					const target = this.getInputForEventTarget(event.target);
					FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
						data: { event, target, selectedOptionValues: this.selectedOptionValues },
					});

					let variant_id = this.updateSelectedSwatchValue(event);

					if (variant_id) {
						document.dispatchEvent(
							new CustomEvent("custom-variants-changed", {
								detail: {
									variantId: variant_id,
								},
							})
						);

						//send info to GTM by getting the product URL from variant-selects
						let variantSelect = document.querySelector("variant-selects");
						if (variantSelect) {
							let productUrl = variantSelect.dataset.url;
							productUrl = productUrl.split("/").pop();
							productUrl = productUrl.split("?")[0];

							if (productUrl && productUrl !== "") {
								productUrl = productUrl.split("?").pop() + "?variant=" + variant_id;
								window.sendProductGTMItems("view_item", productUrl, "pdp");
							}
						}
					}
				});

				// Sticky bar & product infos update on color change
				this.addEventListener("click", (event) => {
					const swatch = event.target.closest(".color-swatch[data-product-url]");
					if (!swatch) return;
					event.preventDefault();

					const productUrl = swatch.dataset.productUrl;
					const productInfo = this.closest("product-info");
					const sectionId = productInfo?.dataset.section;
					const stickyBarSection = document.querySelector('[id^="shopify-section-"][id$="sticky-atc-bar"]');
					const stickyBarSectionId = stickyBarSection?.id.replace("shopify-section-", "");
					const productTabsSection = document.querySelector('[id^="shopify-section-"][id*="product_tabs"]');
					const productTabsSectionId = productTabsSection?.id?.replace("shopify-section-", "");

					// Use getSizeSelect for all size select lookups
					let selectedSize = null;
					const selectedVariantJson = this.querySelector("[data-selected-variant]");
					if (selectedVariantJson) {
						try {
							const variant = JSON.parse(selectedVariantJson.textContent || selectedVariantJson.innerHTML);
							if (variant && variant.option1) selectedSize = variant.option1;
						} catch (e) {}
					}

					if (!productUrl || !sectionId) return;

					// --- Build sections param dynamically ---
					let sectionsParam = [sectionId];
					if (stickyBarSectionId && stickyBarSectionId !== sectionId) sectionsParam.push(stickyBarSectionId);
					if (productTabsSectionId && !sectionsParam.includes(productTabsSectionId)) sectionsParam.push(productTabsSectionId);
					let url = `${productUrl}${productUrl.includes("?") ? "&" : "?"}sections=${sectionsParam.join(",")}`;

					let need_gtm_trigger = true;

					fetch(url)
						.then((res) => res.json())
						.then((data) => {
							const newSectionHtml = data[sectionId];
							const currentSection = document.getElementById(`shopify-section-${sectionId}`);
							if (newSectionHtml && currentSection) {
								const tempDiv = document.createElement("div");
								tempDiv.innerHTML = newSectionHtml;
								const newSection = tempDiv.firstElementChild;
								if (newSection) currentSection.replaceWith(newSection);

								setTimeout(() => {
									var slider = document.querySelector(".main-product-recommendations-slider-wrapper");
									if (slider) {
										//Initializing recommendations slider
										window.initMainProductRecommendationsSlider(slider);
									}
								}, 0);

								setTimeout(() => {
									const stickyBar = document.querySelector(`sticky-atc-bar[data-section="${stickyBarSectionId || sectionId}"]`);
									if (stickyBar) {
										const stickySelect = stickyBar.querySelector('select[name="id"]');
										if (stickySelect) stickySelect.dispatchEvent(new Event("change", { bubbles: true }));
									}

									const updatedVariantSelects = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
									if (updatedVariantSelects && selectedSize) {
										const radios = updatedVariantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="Taille"]');
										let found = false;
										radios.forEach((radio) => {
											if (radio.value === selectedSize && !radio.disabled) {
												radio.checked = true;
												radio.dispatchEvent(new Event("change", { bubbles: true }));
												found = true;
												need_gtm_trigger = false;
											}
										});
										if (!found) {
											for (const radio of radios) {
												if (!radio.disabled) {
													radio.checked = true;
													radio.dispatchEvent(new Event("change", { bubbles: true }));
													need_gtm_trigger = false;
													break;
												}
											}
										}
									}

									const newSlider = document.querySelector(`#shopify-section-${sectionId} .main-product-recommendations-slider-wrapper`);
									if (newSlider) {
										window.initMainProductRecommendationsSlider(newSlider);
									}

									if (need_gtm_trigger) {
										window.history.replaceState({}, "", productUrl); //Edit URL without reloading because it's not done by the theme because no variant is selected
										window.sendProductGTMItems("view_item", productUrl.split("/").pop(), "pdp");
									}
								}, 0);


								setTimeout(() => {
									//get script in current section with id custom-attributes-script and call the function populateAttributes inside it
									const customAttributesScript = newSection.querySelector(`#custom-attributes-script`);
									if (customAttributesScript) {
										const scriptContent = customAttributesScript.textContent || customAttributesScript.innerHTML;

										const populateAttributesFunction = new Function(scriptContent + "; return populateAttributes;");
										const populateAttributes = populateAttributesFunction();
										populateAttributes();
									}
								}, 200);
							}

							// --- Inject product-tabs section ---
							if (productTabsSectionId && data[productTabsSectionId] && productTabsSection) {
								const tempDiv = document.createElement("div");
								tempDiv.innerHTML = data[productTabsSectionId];
								const newProductTabsSection = tempDiv.firstElementChild;
								if (newProductTabsSection) productTabsSection.replaceWith(newProductTabsSection);
							}

							if (stickyBarSectionId && data[stickyBarSectionId]) {
								const newStickyHtml = data[stickyBarSectionId];
								const currentSticky = document.getElementById(`shopify-section-${stickyBarSectionId}`);
								if (newStickyHtml && currentSticky) {
									const tempDiv = document.createElement("div");
									tempDiv.innerHTML = newStickyHtml;
									const newSticky = tempDiv.firstElementChild;
									if (newSticky) currentSticky.replaceWith(newSticky);
								}
							}

							document.dispatchEvent(new Event("shopify:section:load"));
						});
				});
			}

			updateSelectedSwatchValue({ target }) {
				const { value, tagName } = target;

				let variant_id = false;

				if (tagName === "VARIANT-SELECTS") {
					variant_id = document.querySelector(".sticky-atc-bar__variant-select").value || false;
				} else if (tagName === "INPUT" && target.type === "radio") {
					const selectedSwatchValue = target.closest(`.product-form__input`).querySelector("[data-selected-value]");
					if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;

					const variantsJSON = JSON.parse(document.querySelector("[data-all-variants]").textContent);
					for (const variant of variantsJSON) {
						if (variant.option1 === value) {
							variant_id = variant.id;
						}
					}
				} else {
					return false;
				}

				return variant_id;
			}
		}
	);
}
